$(function() {
  const breakpoint = 480;
  let featuredSwiper,
      featuredSwiperBool;
  $(window).on('load', function(){
    if( breakpoint < window.innerWidth){
      featuredSwiperBool = false;
    }else{
      createFeaturedSwiper();
      featuredSwiperBool = true;
    }
  });
  $(window).on('resize', function(){
    if( breakpoint < window.innerWidth && featuredSwiperBool){
      featuredSwiper.destroy(false,true);
      featuredSwiperBool = false;
    }else if( breakpoint >= window.innerWidth && !(featuredSwiperBool)){
      createFeaturedSwiper();
      featuredSwiperBool = true;
    }
  });
  const createFeaturedSwiper = () =>{
    featuredSwiper = new Swiper('.js_featuredSwiper', {
      mode: 'horizontal',
      loop: false,
      slidesPerView: 1.5,
      resizeReInit: true,
      autoHeight: false,
      scrollContainer: true,
      grabCursor: true,
      createPagination: false,
      preventClicks: false,
      freeMode: true,
      freeModeFluid: true,
      spaceBetween: 20,
      dynamicBullets: false,
      mousewheel: {
        invert: true,
        forceToAxis: true
      },
      scrollbar: {
        el: '.js_featuredSwiper_scrollbar',
        draggable: true
      }
    });
  }
});
